module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_location_maedori-d313a954c7920a5c8b6f56ea3d09f14a.webp";